import { useMemo } from "react";
import { useRouteMatch } from "react-router-dom";

import { CreditActivity } from "../../../api/services";
import { formatMoneyWithCR } from "../../../utils/formatMoney";
import { formatBillPeriod } from "../../Financials/utils/formatBillPeriod";

export const useCreditActivity = (activity: CreditActivity) => {
  const { currency, grossAmount, fromDttm, toDttm, creditNumber } = activity;

  const { url } = useRouteMatch();

  return useMemo(
    () => ({
      billPeriod: formatBillPeriod(fromDttm, toDttm),
      title: `Credit Note: ${formatMoneyWithCR(currency, grossAmount, {
        transform: (n) => -n,
      })}`,
      link: `${url}/credits/${creditNumber}`,
    }),
    [creditNumber, currency, fromDttm, grossAmount, toDttm, url],
  );
};
